/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import SearchBar from 'bundles/search-common/components/searchbar/SearchBar';

import 'css!bundles/page-header/components/desktop/__styles__/BrowseContentWrapper';

type Props = {
  className?: string;
  shouldShowCourseraPlusButton?: boolean;
};

type State = {
  searchInputIsFocused: boolean;
};

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
  `,
};

class BrowseContentWrapper extends React.Component<Props, State> {
  state = { searchInputIsFocused: false };

  onFocus = () => {
    this.setState({ searchInputIsFocused: true });
  };

  onBlur = () => {
    this.setState({ searchInputIsFocused: false });
  };

  render() {
    const { className: customClassName, shouldShowCourseraPlusButton } = this.props;
    const { searchInputIsFocused } = this.state;

    return (
      <div
        className={classNames('browse-content-wrapper horizontal-box', {
          [`${customClassName}`]: customClassName !== undefined,
        })}
      >
        <div className="MegamenuWrapperDiv" key="MegamenuWrapperDiv" id="MegamenuWrapperDiv" css={styles.wrapper}>
          <SimplifiedMegaMenuWrapper shouldShowCourseraPlusButton={shouldShowCourseraPlusButton} />
        </div>
        <SearchBar
          key="SearchBar"
          isSearchPage={false}
          searchInputIsFocused={searchInputIsFocused}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          {...this.props}
        />
      </div>
    );
  }
}
export default BrowseContentWrapper;
